module.exports = __webpack_public_path__ + "static/media/HomeCleanProduct.b4a2c990.svg";